import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "preview-wrap-common",
      style: _normalizeStyle({ 'margin-top': _ctx.itemTopSpace ? '-' + _ctx.itemTopSpace : undefined })
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 4)
  ]))
}